import type { ContextParameters } from './types'
import { identity } from 'ramda'
import * as React from 'react'

export const DropdownMultiselectContext = React.createContext<ContextParameters>({
  selectedValues: [],
  removeOption: identity,
  addOption: identity,
  removeOptions: identity,
  addOptions: identity,
})
